import { z } from "zod";
import { apiListSchema } from "./list";
import { PaymentModel } from "./enums";

//? DTO
export const serviceDtoSchema = z.object({
  Id: z.number(),
  Type: z.number().nullish(),
  Name: z.string(),
  Description: z.string().nullish(),
  ReferencePrice: z.number().nullish(),
  DepartmentId: z.number().nullish(),
  PaymentModel: z.number().nullish()
});
export const serviceDtoListSchema = apiListSchema(serviceDtoSchema);

export type ServiceDto = z.infer<typeof serviceDtoSchema>;

export const createServiceDtoSchema = serviceDtoSchema.omit({ Id: true });
export type CreateServiceDto = z.infer<typeof createServiceDtoSchema>;

//? model
export enum ServiceType {
  Labour = 0,
  Transfer = 1,
  Meals = 2,
  MixExpenses = 3,
  Fuel = 4,
  Bikes = 5,
  CarRental = 6,
}

export const ServiceTypeList = Object.values(ServiceType).filter(
  (v) => typeof v === "number",
);

export const PaymentModelList = Object.values(PaymentModel).filter(
  (v) => typeof v === "number",
);

export const serviceSchema = z.object({
  id: z.number(),
  name: z.string().min(1),
  type: z.nativeEnum(ServiceType).nullish(),
  description: z.string().nullish(),
  referencePrice: z.number().nullish(),
  departmentId: z.number().nullish(),
  paymentModel: z.nativeEnum(PaymentModel).nullish()
});
export type Service = z.infer<typeof serviceSchema>;

export const createServiceSchema = serviceSchema.omit({ id: true });
export type CreateService = z.infer<typeof createServiceSchema>;

//? Mappers
export function mapDtoToService(dto: ServiceDto): Service {
  return {
    id: dto.Id,
    name: dto.Name,
    type: dto.Type,
    description: dto.Description,
    referencePrice: dto.ReferencePrice,
    departmentId: dto.DepartmentId,
    paymentModel: dto.PaymentModel
  };
}

export function mapServiceCreateToDto(model: CreateService): CreateServiceDto {
  return {
    Name: model.name,
    Type: model.type,
    Description: model.description,
    ReferencePrice: model.referencePrice,
    DepartmentId: model.departmentId,
    PaymentModel: model.paymentModel
  };
}
export function mapServiceToDto(model: Service): ServiceDto {
  return {
    Id: model.id,
    ...mapServiceCreateToDto(model),
  };
}
